import React, { useState, useEffect } from "react";
import PlusIcon from "../../assets/icons/plus";
import { getGreeting, getSortedData, timeAgo } from "../../Utils/getUserUtitls";
import StatCard from "../Common/StatCard";
import UsersIcon from "../../assets/icons/users";
import LogIcon from "../../assets/icons/log";
import { Link } from "react-router-dom";
import api from "../../setupMiddleware";
import useApiLoader from "../../Utils/useApiLoader";
import Loader from "../Loader/Loader";
import NoteIcon from "../../assets/icons/note";
import Calendar from "../Common/Calendar";
import { getUser, hasPermission, isAdmin, isHR } from "../../Utils/auth";

const Dashboard = () => {
  const user = getUser();
  const [userSummary, setUserSummary] = useState({});
  const [recentActivities, setRecentActivities] = useState([]);
  const [holidayData, setHolidayData] = useState([]);
  const loading = useApiLoader();

  const getUserSummary = async () => {
    await api
      .get("/api/employees-summary")
      .then((res) => {
        if (res && res.status === 200) {
          setUserSummary(res.data?.data);
        }
      })
      .catch((error) => {
        console.log(error.response?.data.message);
      });
  };

  const getAllHolidays = async () => {
    await api
      .get("/api/public-holidays")
      .then((res) => {
        if (res && res.data) {
          setHolidayData(res.data);
        }
      })
      .catch((error) => {
        console.log(error.response?.data.message);
      });
  };

  const getRecentActivity = async () => {
    await api
      .get(`/api/notifications/${user?.id}`)
      .then((res) => {
        if (res && res.status === 200) {
          const recentItems = getSortedData(res?.data?.data);
          setRecentActivities(recentItems);
        }
      })
      .catch((error) => {
        console.log(error.response?.data.message);
      });
  };

  useEffect(() => {
    getUserSummary();
    getAllHolidays();
    getRecentActivity();
  }, []);

  const stats = [
    {
      title: "Total Employee",
      value: userSummary?.total ? userSummary.total : 0,
      Icon: UsersIcon,
    },
    {
      title: "Present Today",
      value: userSummary?.present_today ? userSummary.present_today : 0,
      Icon: NoteIcon,
    },
    {
      title: "Employee On Leave",
      value: userSummary?.on_leave ? userSummary.on_leave : 0,
      Icon: LogIcon,
    },
    {
      title: "Absent Today",
      value: userSummary?.absent ? userSummary.absent : 0,
      Icon: NoteIcon,
    },
  ];

  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            {getGreeting()} {user?.first_name},
          </span>
          <span className="block text-sm text-[#142b70]/50">
            {user?.role?.name} Portal
          </span>
        </p>

        {/* Right Button */}
        {(isAdmin() || hasPermission("add_employees")) && (
          <div className="flex">
            <Link
              to="/add-employee"
              className="flex items-center gap-2 px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] transition text-white text-sm font-medium"
            >
              <PlusIcon iconClass="w-4 h-4" color="#ffffff" />
              Add New Employee
            </Link>
          </div>
        )}
      </div>
      {isAdmin() && isHR() && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full mx-auto px-4 py-3">
          {stats.map((stat, index) => (
            <StatCard key={index} {...stat} />
          ))}
        </div>
      )}
      <div className="flex flex-col md:flex-row gap-6 w-full mx-auto px-4 py-3">
        {/* Right Side Box */}
        <div className="relative w-full bg-white rounded-xl border border-[#a48572]/10 shadow p-4">
          <p>
            <span className="block text-lg font-medium text-[#142b70]">
              Recent Activities
            </span>
          </p>
          <span className="block text-xs text-[#142b70]/80 mb-2">
            Latest updates across the organization
          </span>
          <hr />
          <div className="flex flex-col gap-4 mt-4 h-72 overflow-y-auto">
            {recentActivities.map((activity, idx) => (
              <div
                key={idx}
                className="flex items-start bg-[#c30f0a]/5 p-4 rounded-xl"
              >
                {/* content */}
                <div className="flex flex-col">
                  <span className="text-[12px] text-[#c30f0a]">
                    {activity.type === "leave"
                      ? "Leave Approved"
                      : activity.type === "leave_application"
                      ? "Leave Applied"
                      : activity.type === "user_creation"
                      ? "User Created"
                      : ""}
                  </span>
                  <span className="text-[12px] text-[#142b70]">
                    {activity.message}
                  </span>
                  <span className="text-xs text-[#142b70]/50">
                    {timeAgo(activity.created_at)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Calendar Card */}
        <Calendar events={holidayData} />
      </div>
    </>
  );
};

export default Dashboard;
